import { SitePluginConfigSection } from "@/apidtos";
import { useRootLoaderData } from "@/root"

export const useSitePluginConfig = () => {
  const { config } = useRootLoaderData();
  return config.SitePlugin as SitePluginConfigSection;
};
